import { avatarAnatomy as i } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as n, defineStyle as r } from "@chakra-ui/react";
import { fontSizes as t } from "../../foundations/typography.mjs";
const { defineMultiStyleConfig: a, definePartsStyle: s } = n(i.keys), c = r((e) => {
  const { name: o } = e;
  return {
    bg: o ? "teal.500" : "gray.200",
    color: "white",
    borderColor: "white",
    verticalAlign: "top"
  };
}), f = s((e) => ({
  container: c(e),
  label: {
    textStyle: "body"
  }
}));
function l(e) {
  return {
    container: {
      width: e,
      height: e
    },
    excessLabel: {
      width: e,
      height: e
    }
  };
}
const g = {
  sm: {
    ...l(8),
    label: {
      fontSize: t.sm,
      lineHeight: "24px"
    }
  },
  md: {
    ...l(12),
    label: {
      fontSize: t.xl,
      lineHeight: "32px"
    }
  },
  lg: {
    ...l(16),
    label: {
      fontSize: t["2xl"],
      lineHeight: "32px"
    }
  },
  xl: {
    ...l(20),
    label: {
      fontSize: t["3xl"],
      lineHeight: "48px"
    }
  },
  "2xl": {
    ...l(32),
    label: {
      fontSize: t["4xl"],
      lineHeight: "56px"
    }
  }
}, p = a({
  baseStyle: f,
  sizes: g,
  defaultProps: {
    size: "md"
  }
});
export {
  p as default
};
